import { DispatchCard } from 'src/entities/dispatch';

import { OverloadFlags } from './vehicleAlertReasons';

export type LoadTotals = { cases: number; kg: number; m3: number };

/** 積載の上限。truck マスタの値が無ければ null（= キャパ不明で超過判定の対象外） */
export type CapacityLike = {
  maxCapacity?: number | null;
  maxCapacityKg?: number | null;
  maxCapacityM3?: number | null;
};

/**
 * 実際に積んでいる量。配車済み (matched) の実配送カードだけを数える。
 * 未反映・本日なし・固定ルートの土台は実績ではないので除く。
 */
export function getActualLoad(cards: readonly DispatchCard[]): LoadTotals {
  return cards.reduce<LoadTotals>(
    (acc, card) => {
      if (card.type !== 'delivery' || card.status !== 'matched') return acc;
      acc.cases += card.todayCases ?? 0;
      acc.kg += card.weight ?? 0;
      acc.m3 += card.volume ?? 0;
      return acc;
    },
    { cases: 0, kg: 0, m3: 0 },
  );
}

const over = (current: number, max: number | null | undefined): boolean =>
  max != null && max > 0 && current > max;

/**
 * 積載の超過。表示項目で今どれを見ているかに関わらず 3 つとも判定する
 * （数量を見ているときに重量超過が消えると違反に気づけない）。
 *
 * 判定を VehicleInfoView に閉じ込めず関数へ出しているのは、警告バッジと
 * 「制約違反のある車両のみ」の絞り込みで同じ結果を使うため。
 */
export function buildOverloadFlags(
  vehicle: CapacityLike,
  cards: readonly DispatchCard[],
): Required<OverloadFlags> {
  const load = getActualLoad(cards);
  return {
    quantity: over(load.cases, vehicle.maxCapacity),
    weight: over(load.kg, vehicle.maxCapacityKg),
    volume: over(load.m3, vehicle.maxCapacityM3),
  };
}
